import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createHealthHistory,
  deleteHealthHistory,
  deleteHealthHistoryReport,
  getAllHealthHistories,
  getHealthHistoryByID,
  updateHealthHistory,
  uploadHealthHistoryReports,
} from "./services/healthHistory.services";
import { IHealthHistory, IHealthHistoryInitial } from "./healthHistoryModel";
import moment from "moment";

const initialState: IHealthHistoryInitial = {
  loading: false,
  formLoading: false,
  error: "",
  HealthHistoryList: [],
  HealthHistoryID: null,
  HealthHistoryReportID: null,
  MedicineDeleteIndex: -1,
  ReportDeleteIndex: -1,
  HealthHistoryDetail: {
    LeadID: null,
    Name: "",
    MobileNo: "",
    Date: moment().toDate(),
    Remark: "",
    Height: null,
    Weight: null,
    IsActive: false,
    CreatedBy: "",
    HealthIssueDetails: [],
    AddictionDetails: [],
  },
};

export const healthHistorySlice = createSlice({
  name: "healthHistory",
  initialState,
  reducers: {
    clearHealthHistoryDetails: (state) => {
      state.HealthHistoryDetail = initialState.HealthHistoryDetail;
    },
    setHealthHistoryID: (state, action) => {
      state.HealthHistoryID = action.payload;
    },
    clearHealthHistoryID: (state) => {
      state.HealthHistoryID = initialState.HealthHistoryID;
    },
    setHealthHistoryReportID: (state, action) => {
      state.HealthHistoryReportID = action.payload;
    },
    clearHealthHistoryReportID: (state) => {
      state.HealthHistoryReportID = initialState.HealthHistoryReportID;
    },
    setMedicineDeleteIndex: (state, action) => {
      state.MedicineDeleteIndex = action.payload;
    },
    setReportDeleteIndex: (state, action) => {
      state.ReportDeleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllHealthHistories.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHealthHistories.fulfilled,
      (state, action: PayloadAction<IHealthHistory[]>) => {
        state.loading = false;
        state.HealthHistoryList = action.payload;
      }
    );
    builder.addCase(getAllHealthHistories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HealthHistoryList = initialState.HealthHistoryList;
    });

    builder.addCase(createHealthHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createHealthHistory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHealthHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateHealthHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateHealthHistory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHealthHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteHealthHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHealthHistory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHealthHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHealthHistoryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getHealthHistoryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.HealthHistoryDetail = action.payload;
    });
    builder.addCase(getHealthHistoryByID.rejected, (state, action) => {
      state.loading = false;
      state.HealthHistoryDetail = initialState.HealthHistoryDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(uploadHealthHistoryReports.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(uploadHealthHistoryReports.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(uploadHealthHistoryReports.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteHealthHistoryReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHealthHistoryReport.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHealthHistoryReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearHealthHistoryDetails,
  setHealthHistoryID,
  clearHealthHistoryID,
  setHealthHistoryReportID,
  clearHealthHistoryReportID,
  setMedicineDeleteIndex,
  setReportDeleteIndex,
} = healthHistorySlice.actions;
export default healthHistorySlice.reducer;
